export enum ELocalStorageItems {
  TERMS_OF_SERVICE_AGREEMENTS = 'termsOfServiceAgreements',
  CALCULATOR_CONFIG = 'topics.calculator.config',
  JWT = 'jwt',
  LOCALE = 'locale',
  SIDEBAR_TOGGLE = 'sidebar-toggle',
  FACTSHEET_ID = 'factsheet-id',
  FACTSHEET_TERMS_ACCEPTED = 'factsheet-terms-accepted',
  KC_CONFIG = 'kc-config',
}